import { render, staticRenderFns } from "./FastInNavbar.vue?vue&type=template&id=516149dc&scoped=true"
import script from "./FastInNavbar.vue?vue&type=script&lang=ts"
export * from "./FastInNavbar.vue?vue&type=script&lang=ts"
import style0 from "./FastInNavbar.vue?vue&type=style&index=0&id=516149dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516149dc",
  null
  
)

export default component.exports